App.filter('unumDeclarationPersonaDetailsConsistency', function () {
    return function (profilePerson, declarationPerson) {
        let profileAddress = profilePerson.address;
        let declarationAddress = declarationPerson.address;

        let addressConsistent = (!profileAddress.city || angular.equals(profileAddress.city, declarationAddress.city)) &&
            (!profileAddress.zipCode || angular.equals(profileAddress.zipCode.replace('-', ''), declarationAddress.zipCode.replace('-', ''))) &&
            (!profileAddress.street || angular.equals(profileAddress.street, declarationAddress.street)) &&
            (!profileAddress.number || angular.equals(profileAddress.number, declarationAddress.number)) &&
            (!profileAddress.apartment || angular.equals(profileAddress.apartment, declarationAddress.apartment));

        return addressConsistent && angular.equals(profilePerson.lastName, declarationPerson.lastName) &&
            angular.equals(profilePerson.phone, declarationPerson.phone) &&
            angular.equals(profilePerson.email, declarationPerson.email);
    }
})